import MessageBubble from "./MessageBubble";

const MessageList = ({ messages, loading, containerRef, onScroll }) => {
  return (
    <div
      ref={containerRef}
      onScroll={onScroll}
      style={{
        height: "calc(100vh - 200px)",
        overflowY: "auto",
        padding: "16px",
        background: "#fff",
      }}
    >
      {messages.map((msg) => (
        <MessageBubble key={msg.id} message={msg} />
      ))}

      {loading && <div className="text-center text-muted">Loading...</div>}
    </div>
  );
};

export default MessageList;
